export type RoomMapBgMode = (typeof ROOM_MAP_BG_MODE)[keyof typeof ROOM_MAP_BG_MODE]
export const ROOM_MAP_BG_MODE = {
  FORCE_DARK: 'dark',
  FORCE_LIGHT: 'light',
  USER_CHOICE: 'choice',
}
